/**
 * キャプションテンプレート 14 カテゴリ × 3 パターン = 42 件。
 * docs/CAPTION_TEMPLATES.md と同期 (変更時は両方同時更新)。
 *
 * 純粋データのみ、副作用なし。
 */

import type { CategoryId } from '@shared/types';

/**
 * カテゴリ ID → 3 パターンのテンプレート文字列。
 * 各テンプレートは `[年式]` `[車種]` 等のプレースホルダを含む。
 */
export const TEMPLATES: Readonly<Record<CategoryId, readonly [string, string, string]>> = {
  // 1: hero (ヒーロー写真専用)
  1: [
    'HI-TOP厳選 [年式] [車種] [グレード]。[アピール1]',
    '[車種] [グレード]。当店が自信を持ってお届けする1台',
    '[年式] [車種]。ディテールまで厳選した現車をご覧ください',
  ],
  // 2: exterior_front
  2: [
    'フロントマスク。[車種]ならではの存在感をご確認いただけます',
    '正面外観。[アピール1]',
    '[車種] フロントフェイス。ヘッドライト・グリル状態良好',
  ],
  // 3: exterior_side
  3: [
    'サイドシルエット。ボディラインと[ホイール]の組み合わせ',
    '側面外観。ドアパネル・フェンダーの状態をご確認ください',
    'サイドビュー。[車種]のプロポーションをお楽しみください',
  ],
  // 4: exterior_rear
  4: [
    'リアビュー。テールランプ・リアバンパーの状態良好',
    '後方外観。[アピール1]',
    '[車種] リアセクション。マフラー周り含め現車確認可能',
  ],
  // 5: exterior_diagonal
  5: [
    '斜め前方より。ボディ全体の状態感をお伝えします',
    '3/4ビュー。[車種]のスタイリングを引き立てるアングル',
    '斜め後方より。サイド・リアの質感をご確認ください',
  ],
  // 6: interior_driver
  6: [
    'ドライバーズコックピット。[装備1]を装備',
    '運転席周り。[アピール2]',
    'ステアリング・メーター周り。操作系の状態をご確認ください',
  ],
  // 7: interior_dashboard
  7: [
    '助手席側ダッシュボード。[装備1]搭載',
    'インパネ全景。[車種]の上質な室内空間',
    'ダッシュボード周り。経年に対して状態良好',
  ],
  // 8: interior_rear_seat
  8: [
    'リアシート。[装備2]装備で居住性良好',
    '後席空間。乗員の快適性をご確認ください',
    '後部座席。シート状態・レッグスペースをご確認いただけます',
  ],
  // 9: luggage
  9: [
    'ラゲッジスペース。実用性と[アピール3]を両立',
    'トランク内装。荷室状態良好、日常使いに十分な容量',
    '荷室スペース。フロアマット・内張りまでご確認ください',
  ],
  // 10: engine
  10: [
    'エンジンルーム。整備記録に基づき現状確認済み',
    'ボンネット内。[車種]搭載パワーユニット',
    'エンジン周り。HI-TOPにて点検済みの状態でお渡しします',
  ],
  // 11: wheel_tire
  11: [
    '[ホイール]装着。タイヤ溝・ホイールリム状態をご確認ください',
    '足回り。タイヤ残り溝・ホイール傷の有無を確認可能',
    'ホイール・タイヤ周り。現車の状態をそのままお伝えします',
  ],
  // 12: meter
  12: [
    'メーターパネル。走行距離[走行距離]km時点の状態',
    'インストルメントクラスター。警告灯点灯なし',
    'メーター周り。距離計・各種インジケーターをご確認ください',
  ],
  // 13: navigation
  13: [
    '[装備1]搭載。現代的なインフォテインメント環境',
    'センターコンソール。ナビ・オーディオ周りの装備をご確認ください',
    'インフォテインメント。画面状態・操作系良好',
  ],
  // 14: equipment_detail
  14: [
    '[装備1]の装着状態。装備の実物をご確認いただけます',
    '現車装備のディテール。[アピール2]',
    '付属品・装備状態。詳細は現車にてご確認ください',
  ],
} as const;

/** 合計 42 テンプレート (14 × 3) であることを型で保証するユーティリティ */
export function getAllTemplates(): readonly string[] {
  return Object.values(TEMPLATES).flat();
}
